function getFormAlertBox(form, type = 'success') {
  return form.querySelector(`[data-form-alert="${type}"]`);
}

function resetFormAfterTimeout(form) {
  const allFormFields = form.querySelectorAll('.form-control:not([name="subject"])'),
    requiredFormFields = getRequiredFormFields(form);

  setTimeout(() => {
    allFormFields.forEach(formField => formField.value = '');
    requiredFormFields.forEach(requiredFormField => getFieldWrapperElement(requiredFormField).removeAttribute('data-valid-field'));
    form.removeAttribute('data-valid-form');
  }, 90)

  setTimeout(() => resetAlerts(form), 5000)
}

function resetAlerts(form) {

  const successAlertBox = getFormAlertBox(form);
  const errorAlertBox = getFormAlertBox(form, 'error');

  if (successAlertBox) successAlertBox.removeAttribute('data-active');
  if (errorAlertBox) errorAlertBox.removeAttribute('data-active');
}

export function initDeactivateAlertButtons(form) {

  const deactivateButtons = document.querySelectorAll('.deactivate-button');
  deactivateButtons.forEach(button => button.addEventListener('click', e => {
    e.preventDefault();
    resetAlerts(form);
  }));
}

function setAlertOnValidation(form, isValid) {
  const successAlertBox = getFormAlertBox(form);
  const errorAlertBox = getFormAlertBox(form, 'error');

  if (successAlertBox) successAlertBox.setAttribute('data-active', isValid)
  if (errorAlertBox) errorAlertBox.setAttribute('data-active', !isValid)
}

function validateFormField(formField, validationStatus) {
  getFieldWrapperElement(formField).setAttribute('data-valid-field', validationStatus);
}

export function getFieldWrapperElement(formField) {
  return formField.closest('[data-validation-wrapper]');
}

export function getFormElement(selector = 'form') {
  return document.querySelector(selector);
}

export function getRequiredFormFields(form) {
  return form ? form.querySelectorAll('.form-control[data-validation]') : false;
}

export function formFieldIsValidatedFalse(formField) {
  return getFieldWrapperElement(formField).getAttribute('data-valid-field') === 'false'
}

export function formIsValidatedFalse(form) {
  return form.getAttribute('data-valid-form') === 'false'
}

export function initInvalidateButton(form, invalidateButton) {
  invalidateButton.addEventListener('click', e => {
    e.preventDefault();
    getRequiredFormFields(form).forEach(input => validateFormField(input, false));
    validateForm(form, false);
  });

}

export function initValidateButton(form, validateButton) {
  validateButton.addEventListener('click', e => {
    e.preventDefault();
    getRequiredFormFields(form).forEach(input => validateFormField(input, true));
    resetFormAfterTimeout(form);
  });
}

export function inlineValidationRequest(form, requiredFormField, validation = false) {

  const formData = new FormData(form),
    validationRequest = new XMLHttpRequest();

  validationRequest.open('POST', form.action, true);
  validationRequest.onload = e => inlineValidationHandler(e, requiredFormField, form, validation);

  formData.append('mode', 'validation');
  validationRequest.send(formData);
}

export function inlineValidationHandler(e, requiredFormField, form, validation ) {
  const errorResponse = JSON.parse(e.target.response)

  if (Object.prototype.hasOwnProperty.call(errorResponse, requiredFormField.id)) {
    validateFormField(requiredFormField, false);
    setErrorMessageOnFormField(requiredFormField, errorResponse[requiredFormField.id])
  } else if (formFieldIsValidatedFalse(requiredFormField)) validateFormField(requiredFormField, true);


  if (Object.keys(errorResponse).length === 0 && validation) resetAlerts(form);
}

export function setErrorMessageOnFormField(formField, errorMessage) {
  getFieldWrapperElement(formField).querySelector('.form-validate-message').innerText = errorMessage;
}

export function validateForm(form, bool) {
  setAlertOnValidation(form, bool);
  form.setAttribute('data-valid-form', bool);
}

export function submitForm(form) {
  const formData = new FormData(form),
    submitRequest = new XMLHttpRequest();

  submitRequest.open('POST', form.action);

  submitRequest.onload = e => {
    const hasValidStatus = e.target.status === 200;
    validateForm(form, hasValidStatus);

    if (hasValidStatus) {
      const successfulFormSubmit = new CustomEvent('successfulFormSubmit', {
        detail: {
          formId: form.getAttribute('data-form-id'),
          formTitle: form.getAttribute('data-form-title'),
        }
      });

      document.dispatchEvent(successfulFormSubmit);
      resetFormAfterTimeout(form);
    }
  }

  submitRequest.send(formData);
}
